<template>
  <td
    class="align-content-center"
  >
    {{ allocation.lot_number }}
  </td>
  <td
    class="align-content-center"
  >
    {{ allocation.expiry_date? formatDateTime(allocation.expiry_date): '-' }}
  </td>
  <td
    class="align-content-center text-end"
  >
    {{ formatDigit(allocation.remaining_quantity) }}
  </td>
  <td
    class="align-content-center text-end"
  >
    {{ formatDigit(allocation.currently_used) }}
  </td>
  <td>
    <div class="input-group-sm">
      <input
        type="number"
        v-model.number="v$.allocation.actual_quantity.$model"
        inputmode="decimal"
        class="form-control shadow-none text-end"
        style="font-size: 12px;"
        :placeholder="$t('Enter actual quantity') + '...'"
      >
    </div>
  </td>
  <td
    class="align-content-center"
  >
    {{ $t(allocation.unit) }}
  </td>
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-item-record";
import moment from "moment";
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.allocation)
  },
  props: {
    allocation: {
      type: Object,
      default: []
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    let vm = this;
    return {
    }
  },
  components: {
    Select2
  },
  methods: {
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  async mounted() {},
  computed: {
  },
  watch: {
    "allocation.actual_quantity" (nval, oval) {
      if (nval === oval) return;
      this.allocation.actual_total_cost = (nval * this.allocation.actual_cost_per_unit).toFixed(6);
    },
  }
}
</script>
